/**
 * 2026 contribution limits (spec §4: enforce and display, incl. catch-up and
 * the SECURE 2.0 Roth-catch-up-for-high-earners rule).
 *
 * Source: IRS Newsroom "401(k) limit increases to $24,500 for 2026" and
 * IRS Rev. Proc. 2025-19 (HSA). SECURE 2.0 mandatory-Roth catch-up threshold
 * set at $150,000 (2025 FICA wages) by IRS, effective 2026.
 */
export const CONTRIBUTION_LIMITS_AS_OF = '2026-08-03';

export interface ContributionLimitYear {
  year: number;
  employer: {
    electiveDeferral: number; // 401k/403b/457b employee deferral
    catchUp50: number;
    superCatchUp60to63: number; // replaces catchUp50 for ages 60-63
    overallAdditions415c: number; // employee + employer
  };
  ira: { limit: number; catchUp50: number };
  hsa: { selfOnly: number; family: number; catchUp55: number };
  /** SECURE 2.0: catch-up must be Roth if prior-year wages from the employer exceed this. */
  rothCatchUpWageThreshold: number;
}

export const CONTRIBUTION_LIMITS: Record<number, ContributionLimitYear> = {
  2026: {
    year: 2026,
    employer: {
      electiveDeferral: 24_500,
      catchUp50: 8_000,
      superCatchUp60to63: 11_250,
      overallAdditions415c: 72_000,
    },
    ira: { limit: 7_500, catchUp50: 1_100 },
    hsa: { selfOnly: 4_400, family: 8_750, catchUp55: 1_000 },
    rothCatchUpWageThreshold: 150_000,
  },
};

export function contributionLimits(year: number): ContributionLimitYear {
  const exact = CONTRIBUTION_LIMITS[year];
  if (exact) return exact;
  const years = Object.keys(CONTRIBUTION_LIMITS).map(Number).sort((a, b) => a - b);
  return CONTRIBUTION_LIMITS[years[years.length - 1]!]!;
}
